<template>
<div id="schritt-1">
    <b-row class="cc-point-title-container mt-4">
        <b-col class="col-2 pt-1"><img src="../assets/mobileline.png"></b-col>
        <b-col class="col-8 p-0 ml-1"><h3  id="cost" class="cc-point-title">Schritt 1 - Allgemeine Informationen</h3></b-col>
        <b-col class="col-2 pt-1"></b-col>
    </b-row>
    <div class="page-paddings">
        <div class="cc-questions-container">

            <div class="point-container">
                <div class="row mt-3">
                    <p class="point-number">1. </p>
                    <p class="point-name"> App Format?</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection1.selected1"
                            :options="options1"
                            class="mb-3 input-pad-big"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>
            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">2. </p>
                    <p class="point-name"> Wann ist der Release geplant?</p>
                </div>

                <div class="col">
                    <div>
                        <b-row>
                            <b-col cols="6" class="d-inline-flex justify-content-start align-items-end">
                                <p class="text-white text-left mb-0"> 0 </p></b-col>

                            <b-col cols="6" class="d-inline-flex justify-content-end align-items-end">
                                <p class="text-white text-right mb-0"> 56 Wochen </p></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="mt-5 mb-5" >
                                <vue-slider v-model="value" :min="0" :max="56"
                                            :tooltip-formatter="val => val > 1 ? val + ' Wochen' : val + ' Wochen'"
                                            :tooltipStyle="{ background: 'transparent'}"
                                            :dotStyle="{ background: '#fff' }"
                                            :railStyle="{ background: 'rgba(0, 0, 0, 0.25)' }"
                                            :processStyle="{ background: 'linear-gradient( 90deg, #3079FF, #00FBAF)' }"></vue-slider>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">3. </p>
                    <p class="point-name"> Zielgruppe</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection1.selected3"
                            :options="options3"
                            class="mb-3 input-pad"
                            value-field="item"
                            text-field="name"
                            v-on:input="changeCalView"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>
            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">4. </p>
                    <p class="point-name">Kurze Beschreibung ihrer App:</p>
                </div>

                <div class="drop-container" id="b2a2">
                    <b-row>
                        <p>Kategorie
                        </p><p class="drop-highlighter pl-1 pr-1"> Eigene Mitarbeiter </p>
                    </b-row>
                    <div>
                        <b-form-radio-group
                                v-model="selection1.selectedB2B"
                                :options="optionsB2B"
                                class="mb-3 d-grid"
                                value-field="item"
                                html-field="comment"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-radio-group>

                    </div>
                </div>


                <div class="drop-container" id="b2b2">
                    <b-row>
                        <p>Kategorie </p><p class="drop-highlighter pl-1 pr-1"> B2B </p>
                    </b-row>
                    <div>
                        <b-form-radio-group
                                v-model="selection1.selectedB2B"
                                :options="optionsB2B"
                                class="mb-3 d-grid"
                                value-field="item"
                                html-field="comment"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-radio-group>

                    </div>
                </div>
                <div class="drop-container" id="b2c2">
                    <b-row>
                        <p>Kategorie </p><p class="drop-highlighter pl-1 pr-1"> B2C </p>
                    </b-row>
                    <div>
                        <b-form-radio-group

                                v-model="selection1.selectedB2C"
                                :options="optionsB2C"
                                class="mb-3 d-grid"
                                value-field="item"
                                html-field="comment"
                                text-field="name"
                                disabled-field="notEnabled"
                        ></b-form-radio-group>

                    </div>
                </div>

            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">5. </p>
                    <p class="point-name"> Wichtige Funktionen und Features</p>
                </div>

                <div>
                    <b-form-checkbox-group
                            v-model="selection1.selected5"
                            :options="options5"
                            class="mb-3 d-grid"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-checkbox-group>

                </div>
            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">6. </p>
                    <p class="point-name"> Entwicklungsorganisation</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection1.selected6"
                            :options="options6"
                            class="mb-3 input-pad"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>
            </div>

            <b-row>
                <b-row class="text-right amount-row">
                    <b-col class="col-5"><p class="amount-text mt-3 text-right">Kosten - Schritt 1</p></b-col>
                    <b-col class="col-7"><b-button class="amount-button pl-1  ml-1 text-center">€ {{get1cost}}  </b-button></b-col>
                </b-row>
            </b-row>

        </div>
    </div>
    <b-row class="entry-part-end">
        <b-button @click="nextStep" class="cc-button text-center mx-auto">Weiter</b-button>
    </b-row>

</div>

</template>

<script>
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/material.css'
    export default {
        components: {
            VueSlider
        },
        data() {
            return {
                Cost1:'',
                Cost2: '',
                text1: '',
                text2: '',
                formatter: '',
                // total1: 0,
                total2: 0,
                total3: 0,
                value: 8,
                selection1: {
                    selected1: '',
                    selected2: '',
                    selected3: '',
                    selectedB2B: '',
                    selectedB2C: '',
                    selected5: '',
                    selected6: ''
                },

                result1: '',
                options1: [
                    { item: 'A', name: 'Nativ' },
                    { item: 'B', name: 'Hybrid' },
                    { item: 'C', name: 'Web-App' },
                    { item: 'D', name: 'Mobile Webseite' },
                ],
                options2: [
                    { item: 'A', name: 'Ja', },
                    { item: 'B', name: 'Nein', }
                ],
                options3: [
                    { item: 'A', name: 'Eigene Mitarbeiter' },
                    { item: 'B', name: 'B2B' },
                    { item: 'C', name: 'B2C' }
                ],
                optionsB2B: [
                    { item: 'A', comment: '<p class="b-hover">Customer Relation Management<span data-comment class="comment-info">info</span></p>' },
                    { item: 'B', comment: '<p class="b-hover">Mitarbeiter Weiterbildung<span data-comment class="comment-info">info</span></p>' },
                    { item: 'C', comment: '<p class="b-hover">Weiterbildung allgemein<span data-comment class="comment-info">info</span></p>' },
                    { item: 'D', comment: '<p class="b-hover">Finanzmanagement <span data-comment class="comment-info">info</span></p>' },
                    { item: 'E', comment: '<p class="b-hover">Task Manager <span data-comment class="comment-info">info</span></p>' },
                    { item: 'F', comment: '<p class="b-hover">Messenger <span data-comment class="comment-info">info</span></p>' },
                    { item: 'H', comment: '<p class="b-hover">Unternehmenskommunikation <span data-comment class="comment-info">info</span></p>' },
                    { item: 'J', comment: '<p class="b-hover">Konferenz-App<span data-comment class="comment-info">info</span></p>' },
                    { item: 'K', comment: '<p class="b-hover">Notizverwaltung<span data-comment class="comment-info">info</span></p>' },
                    { item: 'O', comment: '<p class="b-hover">E-Mail-Anwendungen <span data-comment class="comment-info">info</span></p>' },
                    { item: 'M', comment: '<p class="b-hover">Scan-App<span data-comment class="comment-info">info</span></p>' },
                    { item: 'N', comment: '<p class="b-hover">Nachrichten <span data-comment class="comment-info">info</span></p>' },
                    { item: 'S', comment: '<p class="b-hover">Remote Access Service<span data-comment class="comment-info">info</span></p>' },
                    { item: 'T', comment: '<p class="b-hover">Designer-App <span data-comment class="comment-info">info</span></p>' },
                    { item: 'R', comment: '<p class="b-hover">Reservation-App <span data-comment class="comment-info">info</span></p>' },
                    { item: 'Z', comment: '<p class="b-hover">Work-Safety and Security-App<span data-comment class="comment-info">info</span></p>' },
                    { item: 'X', comment: '<p class="b-hover">Online Shop <span data-comment class="comment-info">info</span></p>' },
                    { item: 'Y', comment: '<p class="b-hover">Andere <span data-comment class="comment-info">info</span></p>' }
                ],
                optionsB2C: [
                    { item: 'A', comment: '<p class="b-hover" data-id>Spiele <span data-comment class="comment-info">Abenteuer, Action, Arcade, Brettspiele, Gelegenheitsspiele, Kartenspiele, Kasino, Lernspiele, Musik, Puzzles, Rennsport, Rollenspiele, Simulation, Sportspiele, Strategie, Quizspiele, Worträtsel</span></p>' },
                    { item: 'B', comment: '<p class="b-hover" data-id>Kunst & Design <span data-comment class="comment-info">Zeichenblöcke, Zeichenbedarf, Zubehör für Kunst & Design, Malbücher</span></p>' },
                    { item: 'C', comment: '<p class="b-hover" data-id>Autos & Fahrzeuge <span data-comment class="comment-info">Autokauf, Autoversicherung, Preisvergleich von Autos, Fahrsicherheit, Autobewertungen und -Neuigkeiten</span></p>' },
                    { item: 'D', comment: '<p class="b-hover" data-id>Schönheitspflege <span data-comment class="comment-info">Make-Up-Anleitungen, Styling-Tools, Frisuren, Schönheitsprodukte, Make-Up-Simulatoren</span></p>' },
                    { item: 'E', comment: '<p class="b-hover" data-id>Bücher & Nachschlagewerke <span data-comment class="comment-info">E-Book-Reader, Nachschlagewerke, Textbücher, Wörterbücher, Thesauren, Wikis</span></p>' },
                    { item: 'F', comment: '<p class="b-hover" data-id>Büro <span data-comment class="comment-info">Bearbeiten und Lesen von Dokumenten, Paketverfolgung, Remote Desktop, E-Mail-Verwaltung, Stellensuche</span></p>' },
                    { item: 'H', comment: '<p class="b-hover" data-id>Comics <span data-comment class="comment-info">Comic-Player, Comic-Titel</span></p>' },
                    { item: 'J', comment: '<p class="b-hover" data-id>Kommunikation <span data-comment class="comment-info">SMS/MMS, Chat/IM, Telefonanwendungen, Adressbücher, Browser, Anrufverwaltung</span></p>' },
                    { item: 'K', comment: '<p class="b-hover" data-id>Verabredung <span data-comment class="comment-info">Partnerzuordnung, Kennenlernen, Beziehungen aufbauen, neue Leute kennenlernen, die große Liebe finden</span></p>' },
                    { item: 'O', comment: '<p class="b-hover" data-id>Bildung <span data-comment class="comment-info">Prüfungsvorbereitung, Lernhilfen, Vokabeln, Lernspiele, Sprachtrainer</span></p>' },
                    { item: 'M', comment: '<p class="b-hover" data-id>Unterhaltung <span data-comment class="comment-info">Videos streamen, Filme, Serien, interaktive Unterhaltung</span></p>' },
                    { item: 'N', comment: '<p class="b-hover" data-id>Events <span data-comment class="comment-info">Konzerttickets, Eintrittskarten für Sportveranstaltungen, Weiterverkäufe von Tickets und Kinokarten</span></p>' },
                    { item: 'S', comment: '<p class="b-hover" data-id>Finanzen <span data-comment class="comment-info">Bankgeschäfte, Bezahlung, Geldautomatensuche, Finanznachrichten, Versicherungen, Steuern, Aktienhandel, Trinkgeldrechner</span></p>' },
                    { item: 'T', comment: '<p class="b-hover" data-id>Essen & Trinken <span data-comment class="comment-info">Rezepte, Restaurants, Essenstipps, Wein entdecken & probieren, Getränkerezepte</span></p>' },
                    { item: 'R', comment: '<p class="b-hover" data-id>Gesundheit & Fitness <span data-comment class="comment-info">Persönliche Fitness, Verfolgen von Workout-Erfolgen, Diät- und Ernährungstipps, Gesundheit und Sicherheit</span></p>' },
                    { item: 'Z', comment: '<p class="b-hover" data-id>Haus & Heim <span data-comment class="comment-info">Haus- und Wohnungssuche, Renovierungen, Dekoration, Hypotheken, Immobilien</span></p>' },
                    { item: 'X', comment: '<p class="b-hover" data-id>Software & Demos <span data-comment class="comment-info">Software-Bibliotheken, technische Demos</span></p>' },
                    { item: 'Y', comment: '<p class="b-hover" data-id>Lifestyle <span data-comment class="comment-info">Stilratgeber, Hochzeits- und Partyplanung, Anleitungen</span></p>' },
                    { item: 'W', comment: '<p class="b-hover" data-id>Karten & Navigation <span data-comment class="comment-info">Navigationstools, GPS, Karten, Transittools, öffentliche Verkehrsmittel</span></p>' },
                    { item: 'V', comment: '<p class="b-hover" data-id>Medizin <span data-comment class="comment-info">Arzneimittelverzeichnisse und klinische Nachschlagewerke, Rechner, Handbücher für Gesundheitsdienstleister, medizinische Fachzeitschriften und Nachrichten</span></p>' },
                    { item: 'I', comment: '<p class="b-hover" data-id>Musik & Audio <span data-comment class="comment-info">Musikdienste, Radios, Musikplayer</span></p>' },
                    { item: 'PQ', comment: '<p class="b-hover" data-id>Nachrichten & Magazine <span data-comment class="comment-info">Zeitungen, Nachrichtenaggregatoren, Zeitschriften, Blogs</span></p>' },
                    { item: 'U', comment: '<p class="b-hover" data-id>Eltern <span data-comment class="comment-info">Schwangerschaft, Säuglingspflege- und Überwachung, Kinderbetreuung</span></p>' },
                    { item: 'S', comment: '<p class="b-hover" data-id>Personalisierung <span data-comment class="comment-info">Hintergründe, Live-Hintergründe, Startbildschirm, Sperrbildschirm, Klingeltöne</span></p>' },
                    { item: 'P', comment: '<p class="b-hover" data-id>Fotografie <span data-comment class="comment-info">Kameras, Bildbearbeitungstools, Fotoverwaltung und -weitergabe</span></p>' },
                    { item: 'Q', comment: '<p class="b-hover" data-id>Effizienz <span data-comment class="comment-info">Notepad, Aufgabenliste, Tastatur, Drucken, Kalender, Sicherung, Rechner, Konvertierung</span></p>' },
                    { item: 'L', comment: '<p class="b-hover" data-id>Shopping <span data-comment class="comment-info">Online-Shopping, Auktionen, Gutscheine, Preisvergleich, Einkaufszettel, Produktbewertungen</span></p>' },
                    { item: '1', comment: '<p class="b-hover" data-id>Soziale Netzwerke <span data-comment class="comment-info">Soziale Netzwerke, Check-in</span></p>' },
                    { item: '2', comment: '<p class="b-hover" data-id>Sport <span data-comment class="comment-info">Sportnachrichten und -kommentare, Spielstand, Fantasieteamzusammenstellung, Spielberichterstattung</span></p>' },
                    { item: '3', comment: '<p class="b-hover" data-id>Tools <span data-comment class="comment-info">Tools für Android-Geräte</span></p>' },
                    { item: '4', comment: '<p class="b-hover" data-id>Reisen & Lokales <span data-comment class="comment-info">Reisebuchungstools, Fahrgemeinschaften, Taxis, Stadtführer, Informationen zu lokalen Geschäften und Unternehmen, Reiseverwaltungstools, Reisebuchung</span></p>' },
                    { item: '5', comment: '<p class="b-hover" data-id>Videoplayer & Editors <span data-comment class="comment-info">Videoplayer, Video-Editor, Medienspeicher</span></p>' },
                    { item: '6', comment: '<p class="b-hover" data-id>Wetter <span data-comment class="comment-info"></span></p>' },
                    { item: '7', comment: '<p class="b-hover" data-id>Andere <span data-comment class="comment-info"></span></p>' }
                ],
                options5: [
                    { item: 'A', name: 'Einfachheit' },
                    { item: 'B', name: 'Geschwindigkeit' },
                    { item: 'C', name: 'Weniger Tastatureingabe, mehr Bildschirm-Interaktion' },
                    { item: 'D', name: 'Überzeugendes Benutzer-Feedback' },
                    { item: 'E', name: 'Verschiedene Versionen für verschiedene mobile Geräte' },
                    { item: 'F', name: 'Gute Bildauflösung' },
                    { item: 'H', name: 'Sicherheit' },
                    { item: 'J', name: 'Social Media Networking-Möglichkeiten' },
                    { item: 'K', name: 'Suchfunktion in mobiler Anwendung angezeigt' },
                    { item: 'O', name: 'Ausdrucksvolles Design, kräftige Farben' }
                ],
                options6: [
                    { item: 'A', name: 'Festpreisangebot' },
                    { item: 'B', name: 'Agile Entwicklung' },
                    { item: 'C', name: 'Outstaffing' }

                ]
            }
        },
        mounted() {
            if ('selection1' in localStorage) {
                this.selection1 = JSON.parse(localStorage.getItem('selection1'))
            }
            // localStorage.clear();
            // document.querySelectorAll('[data-id]').forEach(item => {
            //     item.addEventListener('mouseover', () => {
            //         item.querySelector('[data-comment]').classList.add('visible');
            //     });
            //     item.addEventListener('mouseout', () => {
            //         item.querySelector('[data-comment]').classList.remove('visible');
            //     })
            // })
        },
        computed: {
            get1cost() {
                // let total1 = 1;
                let total2 = 0.8;
                let total2pred = this.value;

                let total3 = 0;
                let total4 = 0;
                let total51 = 1;
                let total52 = 1;
                let total53 = 1;
                let total54 = 1;
                let total55 = 1;
                let total56 = 1;
                let total57 = 1;
                let total58 = 1;
                let total59 = 1;
                let total510 = 1;
                let total5 = 0;
                let total6 = 1;




                if (this.selection1.selected1 === 'A') {
                    localStorage.setItem('total1', 1.5);
                } else if ( this.selection1.selected1 === 'B') {
                    localStorage.setItem('total1', 1);
                } else if ( this.selection1.selected1 === 'C') {
                    localStorage.setItem('total1', 0.8);
                } else if ( this.selection1.selected1 === 'D') {
                    localStorage.setItem('total1', 0.5);
                }


                if (this.selection1.selected3 === 'A') {
                    total3 = 0.9;
                } else if ( this.selection1.selected3 === 'B') {
                    total3 = 1.1;
                } else if ( this.selection1.selected3 === 'C') {
                    total3 = 1.2;
                }

                if (this.selection1.selectedB2B === 'A') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2B === 'B') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2B === 'C') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2B === 'D') {
                    total4 = 28;
                } else if ( this.selection1.selectedB2B === 'E') {
                    total4 = 8;
                } else if ( this.selection1.selectedB2B === 'F') {
                    total4 = 8;
                } else if ( this.selection1.selectedB2B === 'H') {
                    total4 = 12;
                } else if ( this.selection1.selectedB2B === 'J') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2B === 'K') {
                    total4 = 8;
                } else if ( this.selection1.selectedB2B === 'O') {
                    total4 = 12;
                } else if ( this.selection1.selectedB2B === 'M') {
                    total4 = 24;
                } else if ( this.selection1.selectedB2B === 'N') {
                    total4 = 24;
                } else if ( this.selection1.selectedB2B === 'S') {
                    total4 = 10;
                } else if ( this.selection1.selectedB2B === 'T') {
                    total4 = 24;
                } else if ( this.selection1.selectedB2B === 'R') {
                    total4 = 36;
                } else if ( this.selection1.selectedB2B === 'Z') {
                    total4 = 9;
                } else if ( this.selection1.selectedB2B === 'X') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2B === 'Y') {
                    total4 = 4;
                }


                if (this.selection1.selectedB2C === 'A') {
                    total4 = 16;
                } else if ( this.selection1.selectedB2C === 'B') {
                    total4 = 12;
                } else if ( this.selection1.selectedB2C === 'C') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'D') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'E') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === 'F') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === 'H') {
                    total4 = 8;
                }else if ( this.selection1.selectedB2C === 'J') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === 'K') {
                    total4 = 20;
                }else if ( this.selection1.selectedB2C === 'O') {
                    total4 = 24;
                }else if ( this.selection1.selectedB2C === 'M') {
                    total4 = 8;
                }else if ( this.selection1.selectedB2C === 'N') {
                    total4 = 24;
                }else if ( this.selection1.selectedB2C === 'S') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'T') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'R') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'Z') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'X') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'Y') {
                    total4 = 20;
                }else if ( this.selection1.selectedB2C === 'W') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === 'V') {
                    total4 = 24;
                }else if ( this.selection1.selectedB2C === 'I') {
                    total4 = 10;
                }else if ( this.selection1.selectedB2C === 'PQ') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'U') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'S') {
                    total4 = 24;
                }else if ( this.selection1.selectedB2C === 'P') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === 'Q') {
                    total4 = 10;
                }else if ( this.selection1.selectedB2C === 'L') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === '1') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === '2') {
                    total4 = 16;
                }else if ( this.selection1.selectedB2C === '3') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === '4') {
                    total4 = 12;
                }else if ( this.selection1.selectedB2C === '5') {
                    total4 = 2;
                }else if ( this.selection1.selectedB2C === '6') {
                    total4 = 2;
                } else if ( this.selection1.selectedB2C === '7') {
                    total4 = 8;
                }




                if (this.selection1.selected5.includes('A') ){
                    total51 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'B') ){
                    total52 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'C') ){
                    total53 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'D') ){
                    total54 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'E') ){
                    total55 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'F') ){
                    total56 = 1.2;
                }
                if ( this.selection1.selected5.includes( 'H') ){
                    total57 = 1.5;
                }
                if ( this.selection1.selected5.includes( 'J') ){
                    total58 = 1.1;
                }
                if ( this.selection1.selected5.includes( 'K') ){
                    total59 = 1.1;
                }
                if ( this.selection1.selected5.includes( 'O') ){
                    total510 = 1;
                }
                this.selection1.selected5 ? total5 =  total51 * total52 * total53 * total54 * total55 * total56 * total57 * total58 * total59 * total510 : 0;

                if (this.selection1.selected6 === 'A') {
                    total6 = 1;
                } else if ( this.selection1.selected6 === 'B') {
                    total6 = 1.5;
                } else if ( this.selection1.selected6 === 'C') {
                    total6 = 0.75;
                }

                total2 = this.isZero(total4 / this.isZero(total2pred))

                if (total2 <= 0.8) {
                    total2 = 0.8
                }
                let get1cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (2 + ((  this.isZero(total3) * this.isZero(total4) * total2) + total5)) * total6);
                localStorage.setItem('get1cost',get1cost)

                return Math.round(get1cost);

            }
        },
        methods: {
            nextStep() {
                localStorage.setItem('selection1', JSON.stringify(this.selection1));
                this.$router.push(
                    {
                        name: 'Schritt2',
                        params: {
                            cost1: this.get1cost,

                        }
                    }
                )
            },
            changeCalView (){

                if ( this.selection1.selected3 === 'B') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    document.getElementById('b2a2').classList.remove("clickedb2b");
                } else if (this.selection1.selected3 === 'C') {
                    document.getElementById('b2c2').classList.add("clickedb2b");
                    document.getElementById('b2b2').classList.remove("clickedb2b");
                    document.getElementById('b2a2').classList.remove("clickedb2b");
                } else if (this.selection1.selected3 === 'A') {
                    document.getElementById('b2a2').classList.add("clickedb2b");
                    document.getElementById('b2b2').classList.remove("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                }
            },
            isZero(value) {
                if (value === 0) {
                    return 1
                }
                return value;
            }
        }
    }
</script>